import { Observable } from "rxjs";

export abstract class IFastAPIService {
  //abstract search(question: string,start: number , rows: number , returnFieldType?: string): Observable<any>;
}
